// extracted by mini-css-extract-plugin
module.exports =  {"root":"Uv2W05SkuZCpLGZ_rCXN","icon":"Y0naMp9Yb0IWo__wWw_r","dropShadow":"y0PvA6iirK8sfTqaKKH_","border":"OMGHrM5BmouGM9Zg3h3z"};